export default __webpack_public_path__ + "static/media/Contact us.2274e80c.png";